import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as actions from '../../actions';

import { cleanString } from '../../util/renderHelper';
import { pathSafeString } from '../../util/pathSafeString';

import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';

const DisplayNewsList = ({ news }) => {
  const displayNewsItem = news.map((item, key) => (
    <li
      id={`provider-news-item-${item.id}`}
      key={`provider-news-item-${item.id}-${key}`}
      className="provider-news__item"
    >
      <a
        href={item.url}
        alt={`${cleanString(item.name)}`}
        className="provider-news__link"
      >
        {cleanString(item.name)} - {item.publishedDate}
      </a>
      <p className="provider-news__summary">{cleanString(item.summary)}</p>
    </li>
  ));
  return <ul className="provider-news__list">{displayNewsItem}</ul>;
};

const ViewMore = ({ url }) => (
  <div className="provider-news__view-more">
    <a href={url} alt="View all" className="provider-news__view-more-link">
      View all
      <IconChevronRight />
    </a>
  </div>
);

class NewsList extends Component {
  componentDidMount() {
    const { dispatch, newsProvider, tabName } = this.props;
    if (pathSafeString(tabName) !== 'provider-news') {
      return;
    }
    !Object.keys(newsProvider).length &&
      dispatch(actions.fetchActions.getProviderNews());
  }

  render() {
    const { newsProvider, newsLoading, newsError, tabName } = this.props;
    return pathSafeString(tabName) === 'provider-news' ? (
      <>
        {Object.keys(newsProvider).length > 0 && !newsLoading && !newsError ? (
          <>
            <DisplayNewsList news={newsProvider.news} />
            <ViewMore url={newsProvider.newsUrl} />
          </>
        ) : null}
        {newsLoading && <p>Loading...</p>}
        {newsError && <p>We have some problems...</p>}
      </>
    ) : null;
  }
}

const mapStateToProps = state => ({
  newsLoading: state.providerResourceNews.loading,
  newsError: state.providerResourceNews.error,
  newsProvider: state.providerResourceNews.data
});
export default connect(mapStateToProps)(NewsList);
